import React from 'react';
import $ from 'jquery';
import LoadStatus from '../../utilities/load-status.jsx';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DataTableButton from './data-table-button.jsx';
import PropTypes from 'prop-types';

class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: this.props.data,
      sortName: undefined,
      sortOrder: this.props.defaultSortOrder,
      page: this.props.page,
      pageCount: this.props.pageCount,
      sizePerPage: this.props.sizePerPage,
      tableColumns: []
    };
    this.controlsFormatter = this.controlsFormatter.bind(this);
    this.chooseDataFormatter = this.chooseDataFormatter.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.getTableOptions = this.getTableOptions.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSizePerPageList = this.onSizePerPageList.bind(this);
    this.loadData = this.loadData.bind(this);
    this.columnGenerator = this.columnGenerator.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      tableData: nextProps.data,
      page: nextProps.page,
      pageCount: nextProps.pageCount,
      sizePerPage: nextProps.sizePerPage,
    }, this.loadData);
  }

  onSortChange(sortName, sortOrder) {
    if (this.props.onSortChange) {
      this.props.onSortChange(sortName, sortOrder);
    } else {
      this.setState({
        sortName,
        sortOrder
      });
      if (sortOrder === 'asc') {
        this.state.tableData.sort((a, b) => {
          if (a[sortName] > b[sortName] || b[sortName] === undefined || b[sortName] === null) {
            return 1;
          } else if (b[sortName] > a[sortName] || a[sortName] === undefined || a[sortName] === null) {
            return -1;
          }
          return 0;
        });
      } else {
        this.state.tableData.sort((a, b) => {
          if ((a[sortName] > b[sortName]) || ((b[sortName] === undefined) && (a[sortName] !== undefined))) {
            return -1;
          } else if ((b[sortName] > a[sortName]) || ((a[sortName] === undefined) && (b[sortName] !== undefined))) {
            return 1;
          } else {
            return 0;
          }
        });
      }
      this.setState({
        tableData: this.state.tableData
      });
    }
  }

  onPageChange(page, sizePerPage) {
    this.setState({
      page: page,
      sizePerPage: sizePerPage
    });
  }

  onSizePerPageList(sizePerPage) {
    this.setState({
      sizePerPage: sizePerPage
    });
  }

  onSearchChange(searchText, colInfos, multiColumnSearch) {
    const text = searchText.trim();
    if (text === '') {
      this.setState({
        tableData: this.state.tableData
      });
      return;
    }
    let searchTextArray = [];
    if (multiColumnSearch) {
      searchTextArray = text.split(' ');
    } else {
      searchTextArray.push(text);
    }
    this.state.tableData.filter(data => {
      const keys = Object.keys(data);
      let valid = false;
      for (let i = 0, keysLength = keys.length; i < keysLength; i++) {
        const key = keys[i];
        if (colInfos[key] && data[key]) {
          const { format, filterFormatted, formatExtraData, searchable, hidden } = colInfos[key];
          let targetVal = data[key];
          if (!hidden && searchable) {
            if (filterFormatted && format) {
              targetVal = format(targetVal, data, formatExtraData);
            }
            for (let j = 0, textLength = searchTextArray.length; j < textLength; j++) {
              const filterVal = searchTextArray[j].toLowerCase();
              if (targetVal.toString().toLowerCase().indexOf(filterVal) !== -1) {
                valid = true;
                break;
              }
            }
          }
        }
      }
      return valid;
    });
    this.setState({
      tableData: this.state.tableData
    });
  }

  columnGenerator() {
    if (this.state.tableColumns.length === 0) {
      const columns = [];
      this.state.tableData.forEach(data => {
        const labels = Object.keys(data);
        labels.forEach(label => {
          if (columns.indexOf(label) === -1) {
            if (this.props.serialize && label === this.props.keyName) {
              columns.unshift(label);
            } else if (this.props.ignoreData.indexOf(label) < 0) {
              columns.push(label);
            }
          }
        });
      });
      this.setState({
        tableColumns: columns
      });
    }
  }

  controlsFormatter(cell, row, formatXtraData, rowId) {
    const tableId = this.props.id ? `-${this.props.id}` : '';
    const betterChildren = React.Children.map(this.props.children, (child, i) => {
      if (child.type === DataTableButton) {
        const newProps = {};
        newProps.id = `data-table-child-button${tableId}-${rowId}-${i}`
        newProps.key = `${i}`;
        newProps.dataLink = row;
        newProps.ignoreData = this.props.ignoreData;
        return React.cloneElement(child, newProps);
      }
      return child;
    });
    return (
      <div style={{ width: '100%', whiteSpace: 'normal', overflowX: 'auto', overflowY: 'hidden' }}>
        {betterChildren}
      </div>
    );
  }

  chooseDataFormatter(dataName) {
    let theFormat = cell => { return cell; };
    let header = dataName;
    let width = `${2.75 + dataName.length}em`;
    if (this.props.formats.length > 0) {
      this.props.formats.forEach(format => {
        if (dataName === format.item) {
          if (format.toType instanceof Function) { theFormat = format.toType; }
          if (format.rename) { header = format.rename; }
          if (format.width) { width = format.width; }
        }
      });
    }
    return { header, width, method: theFormat };
  }

  loadData() {
    const data = this.state.tableData;
    if (this.props.serialize) {
      data.forEach((item, i) => {
        item[this.props.keyName] = i + 1;
      });
      this.setState({
        tableData: data
      }, this.columnGenerator);
    } else {
      this.columnGenerator();
    }
  }

  getTableOptions() {
    const options = {};
    options.onSortChange = this.onSortChange;
    options.sizePerPage = this.props.sizePerPage;
    options.sizePerPageList = this.props.sizePerPageList;
    options.totalSize = this.props.totalSize > 0 ? this.props.totalSize : this.state.tableData.length;
    options.page = this.state.page;
    options.onPageChange = this.props.onPageChange || this.onPageChange;
    options.onSearchChange = this.props.onSearchChange || this.onSearchChange;
    options.onSizePerPageList = this.props.onSizePerPageList || this.onSizePerPageList;
    if (this.props.noDataText) { options.noDataText = this.props.noDataText; }
    if (this.props.defaultSortOrder) { options.defaultSortOrder = this.props.defaultSortOrder; }
    if (this.props.hideSizePerPage) { options.hideSizePerPage = this.props.hideSizePerPage; }
    return options;
  }

  render() {
    const tableOptions = this.getTableOptions();
    const columns = this.state.tableColumns.map((column, i) => {
      const formatter = this.chooseDataFormatter(column);
      return (
        <TableHeaderColumn
          key={`column${i}`}
          dataField={column}
          width={(formatter.width !== undefined && formatter.width !== null) ? formatter.width : '100px'}
          dataFormat={formatter.method}
          dataSort
        >
          {formatter.header}
        </TableHeaderColumn>
      );
    });
    if (this.props.children) {
      columns.push(
        <TableHeaderColumn
          key={`column${columns.length}`}
          dataField="actions"
          width={this.props.controlsFormatterWidth || `${this.props.children.length * 4}em`}
          dataFormat={this.controlsFormatter}
        >
          Controls
        </TableHeaderColumn>);
    }
    const insertionBtn = Boolean(this.props.insertByPage) && Object.keys(this.props.insertByPage).length > 0 && !this.props.loading ? (
      <DataTableButton readApi={this.props.insertByPage.readApi}  theme="btn-success btn-table-insertion" icon="fa-plus" heading="New" action={this.props.insertByPage.action} />
    ) : '';
    return (
      <div style={{ position: 'relative' }} id={this.props.id}>
        <BootstrapTable
          ref="table"
          remote={this.props.remote}
          data={this.state.tableData}
          fetchInfo={this.props.remote ? { dataTotalSize: tableOptions.totalSize } : null}
          width="100%"
          striped
          hover
          pagination={this.props.pageCount > 0 || (this.props.pagination && this.props.data.length > this.props.sizePerPage)}
          search={this.props.search || this.props.multiColumnSearch}
          searchPlaceholder="Search for something"
          multiColumnSearch={this.props.multiColumnSearch}
          options={tableOptions}
          keyField={this.props.keyName}
        >
          {columns}
        </BootstrapTable>
        {insertionBtn}{this.props.addMoreButton}
        {!this.props.loading ? '' : (
          <div
            id="load-status-container"
            className="text-center align-middle"
            style={{
              backgroundColor: 'rgba(51, 51, 51, 0.05)',
              position: 'absolute',
              borderRadius: '5px',
              top: 0, right: '10px', bottom: 0, left: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <LoadStatus size="5em" color="rgba(51, 51, 51, 0.5)" spins />
          </div>
        )}
      </div>
    );
  }
}

DataTable.propTypes = {
  id: PropTypes.string,
  data: PropTypes.array,
  keyName: PropTypes.string,
  formats: PropTypes.array,
  loading: PropTypes.bool,
  remote: PropTypes.bool,
  pagination: PropTypes.bool,
  serialize: PropTypes.bool,
  search: PropTypes.bool,
  multiColumnSearch: PropTypes.bool,
  ignoreData: PropTypes.array,
  insertByPage: PropTypes.object,
  sizePerPage: PropTypes.number,
  totalSize: PropTypes.number,
  page: PropTypes.number,
  pageCount: PropTypes.number,
  onPageChange: PropTypes.func,
  onSortChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  sizePerPageList: PropTypes.array,
  onSizePerPageList: PropTypes.func,
  defaultSortOrder: PropTypes.string,
  hideSizePerPage: PropTypes.bool,
  addMoreButton: PropTypes.element,
  readApi: PropTypes.string,
  noDataText: PropTypes.string,
  controlsFormatterWidth: PropTypes.string
};

DataTable.defaultProps = {
  data: [],
  keyName: 'id',
  formats: [],
  ignoreData: [],
  loading: false,
  serialize: false,
  search: false,
  pagination: false,
  remote: false,
  multiColumnSearch: false,
  sizePerPageList: [5, 10, 20, 50, 100],
  page: 1,
  pageCount: 0,
  sizePerPage: 20,
  totalSize: 0,
  defaultSortOrder: 'asc',
  hideSizePerPage: true,
  noDataText: '- No Data Loaded -'
};

export default DataTable;
